import { render, staticRenderFns } from "./Actors.vue?vue&type=template&id=30951eb6"
import script from "./Actors.vue?vue&type=script&lang=js"
export * from "./Actors.vue?vue&type=script&lang=js"
import style0 from "./Actors.vue?vue&type=style&index=0&id=30951eb6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports